module.exports = __webpack_public_path__ + "assets/img/5ed547d90a69114ed239bf64cfc21f18.png";